module.exports = __webpack_public_path__ + "img/service_japanpost_pc.021208de.svg";